import { CircularProgress } from "@mui/material";

export default function CustomLoader() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
        width: "100%"
      }}
    >
      <CircularProgress />
    </div>
  );
}
